import { computed } from 'vue';
import { EnPowerIdType } from 'Components/types/EnPowerIdType.js';
import { useUserSettingsStore } from 'Js/store/useUserSettingsStore';
/**
 * Composable for user profile related URLs, account switching, and navigation helpers.
 * @returns {Object}
 */
export function useAccountNavigation(pageAuthUrl, pageEngineUrl) {
    const { state } = useUserSettingsStore();
    const authUrl = computed(() => pageAuthUrl);
    const engineUrl = computed(() => pageEngineUrl);
    const userProfileUrl = computed(() => `${engineUrl.value}/Account/Profile/`);
    const enFlowUrls = computed(() => state?.EnFlowUrls || []);
    function navigateTo(url) {
        if (!url)
            return;
        window.location.href = url;
    }
    function buildUrl(url, newEnPower) {
        if (!url)
            return url;
        const newEnPowerId = newEnPower?.Id ?? newEnPower;
        if (url.includes('EnFlowExternal')) {
            return enFlowUrls.value.find(enFlowUrl => enFlowUrl.Id === newEnPowerId)?.Url || url;
        }
        let newUrl = url.replace(EnPowerIdType.defaultEnPowerId, String(newEnPowerId));
        newUrl = newUrl.replace('@EngineServer', engineUrl.value);
        return newUrl;
    }
    function replaceUrl(enPowerAccountId) {
        if (!enPowerAccountId)
            return;
        const currentUrl = new URL(window.location.href);
        const before = currentUrl.href;
        const urlParts = new URL(location.href).pathname.split('/');
        const idx = urlParts.findIndex((s) => typeof s === 'string' && s.toLowerCase() === 'enpower');
        if (idx === -1)
            return;
        urlParts[idx + 1] = enPowerAccountId;
        currentUrl.pathname = urlParts.join('/');
        const after = currentUrl.href;
        if (after !== before) {
            window.location.replace(after);
        }
    }
    function reloadPage(_defaultValue, newValue) {
        if (!location.href.includes(newValue)) {
            replaceUrl(newValue);
        }
    }
    return {
        authUrl,
        userProfileUrl,
        navigateTo,
        buildUrl,
        replaceUrl,
        reloadPage,
    };
}
